export default {
    ACESSO_POLPA_DENTARIA: '0307020010',
    ADAPTACAO_PROTESE_DENTARIA: '0307040143',
    APLICACAO_CARIOSTATICO: '0101020058',
    APLICACAO_SELANTE: '0101020066',
    APLICACAO_TOPICA_FLUOR: '0101020074',
    CAPEAMENTO_PULPAR: '0307010015',
    CIMENTACAO_PROTESE_DENTARIA: '0307040135',
    CURATIVO_DEMORA: '0307020029',
    DRENAGEM_ABSCESSO: '0401010031',
    EVIDENCIACAO_PLACA_BACTERIANA: '0101020082',
    EXODONTIA_DENTE_DECIDUO: '0414020120',
    EXODONTIA_DENTE_PERMANENTE: '0414020138',
    INSTALACAO_PROTESE_DENTARIA: '0307040160',
    MOLDAGEM_PROTESE_DENTARIA: '0307040070',
    ORIENTACAO_HIGIENE_BUCAL: '0101020104',
    REMOCAO_PLACA_BACTERIANA: '0307030040',
    PULPOTOMIA_DENTARIA: '0307020070',
    RASPAGEM_SUPRAGENGIVAIS: '0307030059',
    RASPAGEM_SUBGENGIVAIS: '0307030024',
    RESTAURACAO_DENTE_PERMANENTE_ANTERIOR: '0307010031',
    SELAMENTO_PROVISORIO_CAVIDADE_DENTARIA: '0101020090',
    TRATAMENTO_ALVEOLITE: '0414020383',
    ULOTOMIA_ULECTOMIA: '0414020405',

    MANTENEDOR_DE_ESPAÇO: '0701070064',
    PLACA_OCLUSAL: '0701070072',
    PLANO_INCLINADO: '0701070080 ',
    PROTESE_PARCIAL_MANDIBULAR_REMOVIVEL: '0701070099',
    PROTESE_PARCIAL_MAXILAR_REMOVIVEL: '0701070102',
    PROTESE_TEMPORARIA: '0701070110',
    PROTESE_TOTAL_MANDIBULAR: '0701070129',
    PROTESE_TOTAL_MAXILAR: '0701070137',
    COROA_PROVISORIA: '0701070056',
    PROTESE_CORONARIAS: '0701070145',

    ESCUTA_INICIAL: '0301040079',

    RADIOGRAFIA_OCLUSAL: '0204010160',
	COLOCACAO_PLACA_MORDIDA: '0307040011',
	MANUTENCAOO_CONSERTO_APARELHO: '0307040127',
	CONTENCAOO_DENTES_SPLINTAGEM: '0404020445',
	REDUCAO_LUXACAOO_TEMPORO_MANDIBULAR: '0404020615',
	RETIRADA_MATERIAL_SÍNTESE: '0404020623',
	EXERESE_CISTO: '0414010361',
	TRATAMENTO_CIRURGICO_FISTULA: '0414010388',
	CORRECAO_BRIDAS_MUSCULARES: '0414020049',
	CORRECAO_IRREGULARIDADES_REBORDO_ALVEOLAR: '0414020057',
	REMOCAO_TORUS_EXOSTOSES: '0414020294',
	MANTENEDOR_ESPAÇO: '0701070064',
	MOLDAGEM_DENTO_GENGIVAL: '0307040178',

	RADIOGRAFIA_INTERPROXIMAL: '0204010217',
	RADIOGRAFIA_PERIAPICAL: '0204010225',
	TRATAMENTO_INICIAL_DENTE_TRAUMATIZADO: '0307010066',
	TRATAMENTO_RESTAURADOR_ATRAUMATICO: '0307010074',
	RESTAURACAO_DENTEDECIDUO_POSTERIOR_RESINA_COMPOSTA: '0307010082',
	RESTAURACAO_DENTE_DECIDUO_POSTERIOR_AMALGAMA: '0307010090',
	RESTAURACAO_DENTE_DECIDUO_POSTERIOR_IONOMERO_VIDRO: '0307010104',
	RESTAURACAO_DENTE_DECIDUO_ANTERIOR_RESINA_COMPOSTA: '0307010112',
	RESTAURACAO_DENTE_PERMANENTE_POSTERIOR_RESINA_COMPOSTA: '0307010120',
	RESTAURACAO_DENTE_PERMANENTE_POSTERIOR_AMALGAMA: '0307010139',
	OBTURACAO_DENTE_DECIDUO: '0307020037',
	OBTURACAO_DENTE_PERMANENTE_BIRRADICULAR: '0307020045',
	OBTURACAO_DENTE_PERMANENTE_RAIZES: '0307020053',
	OBTURACAO_DENTE_PERMANENTE_UNIRRADICULAR: '0307020061',
	RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_BIRADICULAR: '0307020088',
	RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_RAIZES: '0307020096',
	RETRATAMENTO_ENDODÔNTICO_DENTE_PERMANENTE_UNIRADICULAR: '0307020100',
	SELAMENTO_PERFURACAO_RADICULAR: '0307020118',
	REEMBASAMENTO_CONSERTO_PROTESE_DENTARIA: '0307040089',
	AJUSTE_OCLUSAL: '0307040151',
	APICECTOMIA: '0414020022',
	CURETAGEM_PERIAPICAL: '0414020073',
	ODONTOSECCAO_RADILECTOMIA_TUNELIZACAO: '0414020219',
	REIMPLANTE_TRANSPLANTE_DENTAL: '0414020243',
	REMOCAO_DENTE_RETIDO: '0414020278',
	TRATAMENTO_CIRURGICO_TRACIONAMENTO_DENTAL: '0414020367',

	APROFUNDAMENTO_VESTIBULO_ORAL: '0414020030',
	GENGIVECTOMIA: '0414020154',
	GENGIVOPLASTIA: '0414020162',
	TRATAMENTO_CIRURGICO_PERIODONTAL: '0414020375',
	RASPAGEM_CORONO_RADICULAR: '0307030032',
	EXODONTIA_MULTIPLA_ALVEOLOPLASTIA: '0414020146',
}